const black = '#000000'
const white = '#FFFFFF'

const loyalty = {
  v300: '#C48FF3',
  v500: '#7808CF',
  v700: '#6C0CAE',
  o300: '#D4A3E7',
  o500: '#9D38C4',
  o700: '#711E91',
  f300: '#E0B1F0',
  f500: '#B92ECB',
  f700: '#9A21AA',
  g1: 'linear-gradient(150deg, #9A21AA 5%, #7808CF 100%)'
}

const neutrals = {
  n100: '#EEEEF0',
  n200: '#D3D2D6',
  n300: '#BAB6BC',
  n400: '#A19BA2',
  n500: '#887F87',
  n600: '#6F676C',
  n700: '#554F52',
  n800: '#3C3738',
  n900: '#222020'
}

const primary = {
  p100: '#EAF3E2',
  p200: '#CBE3B5',
  p300: '#ADD585',
  p400: '#91C854',
  p500: '#78BE20',
  p600: '#41A017',
  p700: '#158110',
  p800: '#0A601B',
  p900: '#053E1F'
}

const reds = {
  r100: '#FEEDEE',
  r200: '#FAB9BC',
  r300: '#F38789',
  r400: '#EA5D58',
  r500: '#DF382B',
  r600: '#B42A27',
  r700: '#8B2226',
  r800: '#641B21',
  r900: '#3E1219'
}

const yellows = {
  y100: '#FFF8E2',
  y200: '#FFEBAF',
  y300: '#FEE07D',
  y400: '#FCD64C',
  y500: '#F8CC1C',
  y600: '#C9A21B',
  y700: '#9C7B18',
  y800: '#705613',
  y900: '#46350D'
}

const brand = {
  primary: primary.p500,
  gray: neutrals.n500,
  loyalty: '#AA25D7'
}

const semantic = {
  success: primary.p500,
  danger: reds.r500,
  warning: yellows.y500,
  default: neutrals.n500
}

const misc = {
  background: '#F8F8F8'
}

export default {
  colors: {
    white,
    black,
    ...primary,
    ...yellows,
    ...reds,
    ...neutrals,
    ...semantic,
    ...loyalty,
    ...misc,
    brand
  },
  font: {
    family: {
      default: '"Leroy Merlin Sans", sans-serif'
    },
    weight: {
      regular: 400,
      semibold: 600,
      bold: 800
    }
  },
  media: {
    mobile: {
      sm: '320px',
      md: '375px',
      lg: '425px'
    },
    tablet: '768px',
    laptop: {
      sm: '960px',
      md: '1024px',
      lg: '1440px'
    },
    desktop: '2560px'
  },
  layer: {
    lowest: -10,
    low: -1,
    base: 10,
    medium: 50,
    high: 100,
    highest: 1000
  }
}
